import React from "react";
import PropTypes from "prop-types";
import cn from 'classnames';

const NavbarItem = ({ title, children, index, onMouseEnter, theme }) => {
  const onMouse = () => {
    onMouseEnter(index)
  }
  return(
    <li className="relative" onMouseEnter={onMouse} onFocus={onMouse} style={{ zIndex: 60 }}>
      <button
        className={cn(theme.logo, 'bg-transparent text-sm flex justify-center px-4 border-0 relative z-10 hover:text-opacity-70')}
        type="button"
      >
        {title}
      </button>
      <div className="absolute left-1/2 transform -translate-x-1/2 pt-8" style={{ perspective: '1500px' }}>{children}</div>
    </li>
  )
}

NavbarItem.propTypes = {
  onMouseEnter: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}

export default NavbarItem;